import {DeviceSize, useDeviceSize} from '../theme/helpers';
import {useMemo} from 'react';

export const useIsDesktop = () => {
  const deviceSize = useDeviceSize();
  return useMemo(() => deviceSize === DeviceSize.desktop, [deviceSize]);
};
